<div class="admin-box">
  <div class="admin-action-row">
    <button
      mat-stroked-button
      disableRipple="true"
      class="secondary_materials_button small_button"
      (click)="onSave()"
      [disabled]="isSaveDisabled">
      @if (isSaving) {
        <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
      }
      Save
    </button>
    @if (canRevert) {
      <span [matTooltip]="disableRevertMessage" [matTooltipDisabled]="!isRevertDisabledByPolicy">
        <button
          mat-stroked-button
          disableRipple="true"
          class="secondary_materials_button small_button"
          (click)="onRevert()"
          [disabled]="isReverting || isRevertDisabledByPolicy">
          @if (isReverting) {
            <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
          }
          {{ revertLabel }}
        </button>
      </span>
    }
  </div>
</div>
